import { TitleCasePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';

export interface DeleteTemplateModalComponentData {
  name: string;
  type: string;
}

@Component({
  selector: 'ps-ui-delete-template-modal',
  templateUrl: './delete-template-modal.component.html',
  styleUrls: ['./delete-template-modal.component.css'],
})
export class DeleteTemplateModalComponent implements OnInit {
  constructor(
    private _modalRef: ModalRef<DeleteTemplateModalComponent, string>,
    @Inject(ModalData)
    private _modalData: DeleteTemplateModalComponentData,
    private titlecasePipe: TitleCasePipe
  ) {}
  public text: string = '';
  ngOnInit() {
    const type = this.titlecasePipe.transform(this._modalData.type);
    this.text =
      `Do you want to delete the ${type} named ${this._modalData.name}?` || '';
  }

  close(msg: string) {
    this._modalRef.close(msg);
  }
}
